import React, { Component }  from 'react'
import { Provider as StateProvider } from 'react-redux'
import Routes from './routes'
import configureStore from './redux/configureStore'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import './App.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { AbilityContext } from './config/Can'
import { buildAbilityFor } from './config/ability'

library.add(fas, fab, far)
const store = configureStore()

class App extends Component {
  state = {
    ability: buildAbilityFor({
      enabled: true,
      email: '',
      first_name: '',
      last_name: '',
      organization_id: 0,
      organization_name: '',
      organization_tax_id_number: 0,
      organization_address_1: '',
      organization_address_2: '',
      organization_city: '',
      organization_state: '',
      organization_zip_code: '',
      organization_data: [],
      provider_data: [],
      role: '',
      role_id: 0,
      user_id: 0
    })
  }

  componentDidMount () {
    let currentAuth
    store.subscribe(() => {
      const prevAuth = currentAuth
      currentAuth = store.getState().authentication.user.data
      if (prevAuth !== undefined) {
        if (prevAuth.role !== currentAuth.role) {
          const ability = buildAbilityFor(currentAuth)
          this.setState({
            ability
          })
        }
      }
    })
  }
  
  render(){
    const { ability } = this.state
	  return (
      <div className="App">
        <AbilityContext.Provider value={ability}>
          <StateProvider store={store}>
            <Routes />
          </StateProvider>
        </AbilityContext.Provider>
      </div>
    )
  }
}

export default App
